module.exports = __webpack_public_path__ + "img/qgew-2-32-50.prt.280a29cf.jpg";